import validationSchema from "../validationSchema";

const formikSchema = (brand) => ({
  initialValues: {
    brand: brand?.id,
    name: "",
    image: null,
    category: brand?.category,
    description: "",
    minimumMargin: null,
    maximumMargin: null,
    suggestedMargin: 0,
    minimumOrderDollarAmount: null,
    minimumOrderItems: 0,
    maximumOrderDollarAmount: null,
    maximumOrderItems: null,
    commissionCost: null,
    shippingCost: null,
    otherCosts: null,
    soldByCaseOnly: null,
    currency: brand?.currency.code || "USD",
    lineItemsFile: null,
    skuassortment: null,
    fobPoint: null,
    leadTime: null,
    cutoffdate: null,
    notes: brand?.notes,
    notesForCustomers: brand?.notesForCustomers,
    status: brand?.status || "unapproved",
    dealByDeal: false,
  },
  validationSchema,
});

export default formikSchema;
